import { useInfiniteQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash-es';

import type { DomainListShopNotificationsResponse, Shops } from '@/Swagger';
import axiosInstance from '@/axios/axios';
import type { UseAxiosQueryOptions } from '@/utils/typeHelper';

type Request = Shops.NotificationsList.RequestQuery;
type QueryOptions = UseAxiosQueryOptions<DomainListShopNotificationsResponse, ['notifications', { shopID: string }]>;

/**
 * 샵의 알람을 가져온다.
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Notifications/get_shops__shopID__notifications
 */
export const useInfiniteQueryGetNotifications = ({
  shopID,
  request,
  options,
}: {
  shopID?: string;
  request: Request;
  options?: Partial<QueryOptions>;
}) =>
  useInfiniteQuery({
    queryKey: ['notifications', { shopID }] as const,

    queryFn: ({ pageParam }) =>
      axiosInstance.get<DomainListShopNotificationsResponse>(`/shops/${shopID}/notifications`, {
        params: { ...request, pageNumber: pageParam },
        ...options,
      }),
    initialPageParam: 1,
    enabled: !isEmpty(shopID),
    getNextPageParam: lastPage => {
      return (lastPage.data.notifications?.length ?? 0) < (lastPage.data.pagination?.pageSize ?? 100)
        ? undefined
        : (lastPage.data.pagination?.pageNumber ?? 0) + 1;
    },
  });
